module.exports = "pegasus/assets/theme5/l_w.png";